<template>
  <svg width="140" height="140" viewBox="0 0 140 140" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M57.622 20.4878C57.622 23.3166 59.9152 25.6097 62.744 25.6097H80.6708C83.4996 25.6097 85.7928 23.3166 85.7928 20.4878H57.622Z" :fill="color" />
    <path
      d="M61.8903 113.11C69.558 113.11 73.8569 113.11 81.5245 113.11M57.622 20.4878H51.2196C48.3908 20.4878 46.0977 22.781 46.0977 25.6097L46.0977 67.8658M57.622 20.4878V20.4878C57.622 23.3166 59.9152 25.6097 62.744 25.6097H80.6708C83.4996 25.6097 85.7928 23.3166 85.7928 20.4878V20.4878M57.622 20.4878H85.7928M85.7928 20.4878H92.1952C95.024 20.4878 97.3172 22.781 97.3172 25.6097V34.5732M97.3172 70V105.854V114.39C97.3172 117.219 95.024 119.512 92.1952 119.512H51.2196C48.3908 119.512 46.0977 117.219 46.0977 114.39V101.585"
      :stroke="color"
      stroke-width="3.41463"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M90.9148 47.8049H107.561M90.9148 52.0732H110.976M90.9148 56.3415H98.1709M86.2197 65.7318V45.244C86.2197 43.8296 87.3663 42.683 88.7807 42.683H113.964C115.378 42.683 116.525 43.8296 116.525 45.244V58.9025C116.525 60.3169 115.378 61.4635 113.964 61.4635H94.8706C93.9574 61.4635 93.0608 61.7076 92.2736 62.1706L86.2197 65.7318Z"
      :stroke="color"
      stroke-width="2.56098"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M49.5116 78.5366V78.5366C49.5116 77.1222 48.3651 75.9756 46.9507 75.9756H26.4629C25.0485 75.9756 23.9019 77.1222 23.9019 78.5366V78.5366M49.5116 78.5366L39.2677 85.3658M49.5116 78.5366V90.9146M23.9019 78.5366L34.1458 85.3658M23.9019 78.5366V90.9146M39.2677 85.3658L38.1273 86.1261C37.2671 86.6996 36.1464 86.6996 35.2862 86.1261L34.1458 85.3658M39.2677 85.3658L49.5116 90.9146M34.1458 85.3658L23.9019 90.9146M49.5116 90.9146V91.3414C49.5116 92.7558 48.3651 93.9024 46.9507 93.9024H26.4629C25.0485 93.9024 23.9019 92.7558 23.9019 91.3414V90.9146M54.6336 79.3902H67.4385M53.7799 84.939H63.597"
      :stroke="color"
      stroke-width="2.56098"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'ChannelsSvg',
  props: {
    color: {
      type: String,
      default: '#000000'
    }
  }
}
</script>

<style lang="scss" scoped></style>
